import Empty from 'constants/empty';

const rougeExclusiveRewardsSelector = store => store.rougeExclusiveRewards || Empty.Object;

export { rougeExclusiveRewardsSelector };
